import React from 'react';
import type { ChargeBeePlanId } from '@prerender/billing-shared';

import SearchPerformanceCtaRow from './SearchPerformanceCtaRow';
import SearchPerformanceUpgradeCta from './SearchPerformanceUpgradeCta';

type Props = {
  message: string;
  ctaLabel: string;
  targetPlanId: ChargeBeePlanId;
  ctaLocation: string;
};

function SearchPerformanceUpgradeRow({ message, ctaLabel, targetPlanId, ctaLocation }: Props) {
  return (
    <SearchPerformanceCtaRow message={message}>
      <SearchPerformanceUpgradeCta
        type="primary"
        targetPlanId={targetPlanId}
        ctaLocation={ctaLocation}
        ctaName={ctaLabel}
        style={{ flexShrink: 0 }}
      >
        {ctaLabel}
      </SearchPerformanceUpgradeCta>
    </SearchPerformanceCtaRow>
  );
}

export default SearchPerformanceUpgradeRow;
